import axios from 'axios'

var endpoint = axios.create({
    baseURL: '/api',
    timeout: 5000,
    headers: {
        'X-Auth-Token': 'f2b6637ddf355a476918940289c0be016a4fe99e3b69c83d',
        'Content-Type': 'application/json'
    }
})


var portfolio = {
	async getStock(symbol) {
		return await endpoint.get('stock/' + symbol);
	},
	async getPortfolio() {
		return await endpoint.get('portfolio');
	},
	async getCollections() {
		return await endpoint.get('collection');
	}
}

export default portfolio 
